'use client';

import {
  EMPTY_TOKEN_IN,
  useYodlStore,
} from '@frontend/client/contexts/useYodlStore';
import { useCallback } from 'react';

export function useClearPaymentState() {
  const setTokenIn = useYodlStore((state) => state.setTokenIn);
  const setTokenSelection = useYodlStore((state) => state.setTokenSelection);
  const setSwapQuote = useYodlStore((state) => state.setSwapQuote);
  const setAcrossQuote = useYodlStore((state) => state.setAcrossQuote);
  const setTokenInAmount = useYodlStore((state) => state.setTokenInAmount);
  const setTokenOut = useYodlStore((state) => state.setTokenOut);

  return useCallback(() => {
    setTokenIn(undefined);
    setTokenSelection(undefined);
    setSwapQuote(undefined);
    setAcrossQuote(undefined);
    setTokenInAmount(EMPTY_TOKEN_IN);
    setTokenOut(undefined);
  }, [
    setTokenIn,
    setTokenSelection,
    setSwapQuote,
    setAcrossQuote,
    setTokenInAmount,
    setTokenOut,
  ]);
}
